export const CHAT_VERSION = "3.2.0-beta.2111975883";
//# sourceMappingURL=version.js.map